import produce from '../../produce';

import * as types from './types';

const initialState = {
  wished_products: []
};

/* eslint-disable consistent-return */
/* eslint-disable default-case */
/* eslint-disable no-param-reassign */
const reducer = produce((draft, action) => {
  switch (action.type) {
    case types.LISTS_UPDATE_WISHLIST:
      draft.wished_products = action.wishlist;
      break;

    case types.LISTS_ADD_PRODUCT_TO_LIST:
      draft.wished_products.push(action.product);
      break;

    case types.LISTS_REMOVE_PRODUCT_FROM_LIST:
      draft.wished_products = draft.wished_products.filter((x) => x.id !== action.product);
      break;
  }
}, initialState);

export default reducer;
